import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { secretCodeAES } from "./app-constant";
import { store } from "../admin/hooks/redux/store";


export const toastEmitter = (type = "info", message = "") => {
    let customClass = "toast-custom-size";
    switch (type) {
        case "success":
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                className: customClass,
            });
            break;
        case "warn":
            toast.warn(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                className: customClass,
            });
            break;

        case "error":
            toast.error(message, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                className: customClass,
            });
            break;
        case "info":
            toast.info(message, {
                icon: false,
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                progressClassName: "toast-progress-info",
                className: "toast-icon-info",
                className: customClass,
            });
            break;
        default:
            toast(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                className: customClass,
            });
            break;
    }
};
export const encryptJSONtoAES = (str) => {
    if (!str) return false;
    return CryptoJS.AES.encrypt(str, secretCodeAES).toString();
};

export const decryptAEStoJSON = (str) => {
    if (!str) return false;
    const bytes = CryptoJS.AES.decrypt(str, secretCodeAES);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const encryptStringtoAES = (str) => {
    if (!str) return false;
    return CryptoJS.AES.encrypt(str.toString(), secretCodeAES).toString();
};

export const decryptAEStoString = (str) => {
    if (!str) return false;
    const bytes = CryptoJS.AES.decrypt(str, secretCodeAES);
    return bytes.toString(CryptoJS.enc.Utf8);
};

export const getCurrentUser = () => {
    let state = store.getState(),
        loggedUser = state.loggedUser.value;
    loggedUser = loggedUser ? decryptAEStoJSON(loggedUser) : false;
    return loggedUser;
};

export const modifyTableDate = (str) => {
    if (!str) return false;
    return new Date(str).toLocaleString();
};
